<!-- CustomInput.vue -->
<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import TooltipInput from "@/components/others/TooltipInput.vue";

export default {
  components: {TooltipInput},
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  props: {
    id: String,
    labelName: String,
    required: '',
    modelValue: String,
    step: '',
    tip: '',
    inputType: String
  },
  data() {
    return {
      store,
      typeInput: ''

    }
  },
  emits: ['update:modelValue'],
  methods: {},
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    isRequired() {
      if (this.required) {
        if (this.required.length > 0) return true;
      } else return false;
    },
    isBlurred() {
      if (this.step) {
        if (this.store.form.steps[this.step].blurred) return true; else return false;
      }
    },
    hasTip() {
      if (this.tip) {
        if (this.tip.length > 0) return true;
        else return false;
      } else return false;
    }
  },

}
</script>

<template>
  <div class="form-label-group">
    <input type="text" v-if="!isRequired" :name="id" :id="id" class="form-control" v-model="value"
           :placeholder="t(labelName)"/>
    <input  type="text" v-if="isRequired" :name="id" :id="id" class="form-control" v-model="value"
           :placeholder="t(labelName)"
           :class="{'is-invalid': isRequired && !value && isBlurred}" required=""/>
    <TooltipInput v-if="hasTip && !(isRequired && !value && isBlurred)" :title="tip"></TooltipInput>
    <label :for="id">
      <!--    Nazev v prekladu-->
      {{ t(labelName) }}</label>
    <div v-if="isRequired" class="invalid-feedback">
      {{ t(required) }}
    </div>
  </div>
</template>